import { ReactElement } from "react";

import { OptOutListPage } from "~frontend/components/optouts/OptOutListPage";
import {
  useSubaccount,
  useSubaccountAdminConfig,
} from "~frontend/providers/SubaccountProvider";

export const OptOuts = (): ReactElement => {
  const { subaccountLink } = useSubaccount()!;
  const subaccount = useSubaccountAdminConfig()!;

  return (
    <OptOutListPage subaccount={subaccount} subaccountLink={subaccountLink} />
  );
};
